import Section from 'components/forms/Section';
import fields from 'components/forms/tankerman/fields';
import {bootstrapOldForm} from 'components/forms/AutoSection';
import TankermanTable from 'components/forms/fields/table/TankermanTable';

const CompletionDischarges = props => {
    const {schema, initialValues} = bootstrapOldForm(
        'CompletionDischarges',
        fields
    );

    return (
        <Section {...props} {...{schema, initialValues}}>
            <TankermanTable
                label='Adding Completion of Discharges'
                name='completion_discharges'
                type='Discharge'
                required
            />
        </Section>
    );
};

export default CompletionDischarges;
